export default "/images/vendor/flag-icons/flags/4x3/pm.svg?f290a4bcb2060c82a15c08a34dba04e2";